import React from "react";
import * as styles from "./Footer.module.css";
import { Link } from "gatsby";
import { HoursText } from "../../../lib/useOpenHours";
import { CookieBanner } from "../../blocks/CookieBanner/CookieBanner";
import { FooterNavigation } from "../../../lib/useFooter";
import { RichTextElement } from "@kontent-ai/gatsby-components";
import { KontentLink } from "../../../types";
import { formatLinks } from "../../../lib/links";
import { RichTextSemanticLinks } from "../../elements/RichTextSemanticLinks/RichTextSemanticLinks";

interface Props {
  libraryHours: HoursText[];
  footerData?: FooterNavigation;
}

export const Footer: React.FC<Props> = ({ libraryHours, footerData }) => {
  const currentYear = new Date().getFullYear();

  return (
    <section className={styles.footer}>
      <div className={styles.content}>
        <div className={styles.infoColumn}>
          <div className={styles.infoItem}>
            <h3>Library Hours</h3>
            <div>
              {footerData?.hoursOfOperation?.value && (
                <RichTextElement {...footerData?.hoursOfOperation} />
              )}
            </div>
          </div>
          <div className={styles.infoItem}>
            <h3>Telephone</h3>
            <a href="tel:8163634600">816.363.4600</a>
          </div>
          <div className={styles.infoItem}>
            <h3>Address</h3>
            <address>
              5109 Cherry Street
              <br />
              Kansas City, Missouri
              <br />
              64110-2498
            </address>
          </div>
        </div>
        {footerData?.links?.modular_content?.length && (
          <RichTextSemanticLinks
            content={footerData?.links}
            classes={styles.linkColumns}
          />
        )}
        <ul className={styles.socialColumn}>
          {footerData?.facebookUrl && (
            <li>
              <a href={footerData?.facebookUrl} target="_blank">
                <svg>
                  <use xlinkHref="/icons/facebook.svg#img"></use>
                </svg>
                <span className="vis-hidden">The Linda Hall on Facebook</span>
              </a>
            </li>
          )}
          {footerData?.twitterUrl && (
            <li>
              <a href={footerData?.twitterUrl} target="_blank">
                <svg>
                  <use xlinkHref="/icons/twitter.svg#img"></use>
                </svg>
                <span className="vis-hidden">The Linda Hall on Twitter</span>
              </a>
            </li>
          )}
          {footerData?.tumblrUrl && (
            <li>
              <a href={footerData?.tumblrUrl} target="_blank">
                <svg>
                  <use xlinkHref="/icons/tumblr.svg#img"></use>
                </svg>
                <span className="vis-hidden">The Linda Hall on Tumblr</span>
              </a>
            </li>
          )}
          {footerData?.vimeoUrl && (
            <li>
              <a href={footerData?.vimeoUrl} target="_blank">
                <svg>
                  <use xlinkHref="/icons/vimeo.svg#img"></use>
                </svg>
                <span className="vis-hidden">The Linda Hall on Vimeo</span>
              </a>
            </li>
          )}
          {footerData?.instagramUrl && (
            <li>
              <a href={footerData?.instagramUrl} target="_blank">
                <svg>
                  <use xlinkHref="/icons/instagram.svg#img"></use>
                </svg>
                <span className="vis-hidden">The Linda Hall on Instagram</span>
              </a>
            </li>
          )}
          {footerData?.youtubeUrl && (
            <li>
              <a href={footerData?.youtubeUrl} target="_blank">
                <svg>
                  <use xlinkHref="/icons/youtube.svg#img"></use>
                </svg>
                <span className="vis-hidden">The Linda Hall on Youtube</span>
              </a>
            </li>
          )}
        </ul>
      </div>
      <div className={styles.logo}>
        <img
          src="/images/lhl-logo-inline.svg"
          alt="The Linda Hall: Science Library and Arboretum"
        />
      </div>
      <div className={styles.copyright}>
        &copy;{currentYear}, The Linda Hall: Science Library and Arboretum, All
        Rights Reserved
      </div>
      <CookieBanner />
    </section>
  );
};
